__turbopack_context__.v({
  "caret-blink": "inputOtp-module__zU4WWq__caret-blink",
  "fakeCaret": "inputOtp-module__zU4WWq__fakeCaret",
  "slot": "inputOtp-module__zU4WWq__slot",
  "slotActive": "inputOtp-module__zU4WWq__slotActive",
  "slotDisabled": "inputOtp-module__zU4WWq__slotDisabled",
});
